import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_URL, NAV_LINKS, CONTACT } from "./constants";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-slate-200/70 shadow-[0_4px_24px_-12px_rgba(10,19,48,0.12)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#anasayfa"
            data-testid="nav-logo"
            className="flex items-center gap-2 group"
          >
            <img
              src={LOGO_URL}
              alt="AjansBilir"
              className="h-12 w-12 object-contain rounded-md"
            />
            <div className="leading-tight block">
              <div className="font-display font-extrabold text-[1.15rem] text-[var(--ab-navy)]">
                Ajans<span className="text-[var(--ab-blue)]">Bilir</span>
              </div>
              <div className="text-[0.65rem] tracking-[0.18em] uppercase text-slate-500">
                Dijital Çözümler
              </div>
            </div>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`nav-link-${l.id}`}
                className="px-4 py-2 text-sm font-medium text-slate-700 hover:text-[var(--ab-blue)] transition-colors rounded-full hover:bg-slate-100"
              >
                {l.label}
              </a>
            ))}
          </nav>

          {/* CTAs */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={CONTACT.phoneLink}
              data-testid="nav-phone-btn"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--ab-navy)] hover:text-[var(--ab-blue)] transition-colors"
            >
              <Phone className="h-4 w-4" />
              {CONTACT.phoneDisplay}
            </a>
            <a
              href={CONTACT.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-whatsapp-btn"
              className="ab-btn-primary inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold"
            >
              WhatsApp&apos;tan Ulaş
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 rounded-full border border-slate-200 bg-white"
            aria-label="Menüyü Aç"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <nav className="px-4 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.id}`}
                className="px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg"
              >
                {l.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 mt-3 px-2">
              <a
                href={CONTACT.phoneLink}
                data-testid="nav-mobile-phone"
                className="ab-btn-secondary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold"
              >
                <Phone className="h-4 w-4" />
                {CONTACT.phoneDisplay}
              </a>
              <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="nav-mobile-whatsapp"
                className="ab-btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full text-sm font-semibold"
              >
                WhatsApp&apos;tan Ulaş
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
